import { render, staticRenderFns } from "./BasicText.vue?vue&type=template&id=3713c79c&"
import script from "./BasicText.vue?vue&type=script&lang=js&"
export * from "./BasicText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports